module.exports = __webpack_public_path__ + "img/positive.73a4078c.png";